<template>
    <Typography
        :class="$style.rating"
        type="label"
        size="s"
        :responsive="false"
    >
        <SeoOnly is="span">
            <meter
                min="0"
                max="5"
                :value="props.rating.value"
            />
        </SeoOnly>
        <span
            :class="$style.average_rating"
            :style="{
                '--rating': props.rating.value,
            }"
            aria-hidden="true"
            >★★★★★</span
        >
        <span
            v-if="props.showLabel"
            :class="$style.rating_text"
        >
            {{ props.rating.value }}
        </span>
        <span
            v-if="props.showLabel"
            :class="$style.votes"
            >{{ '\u00A0/\u00A0' + $tr('stars.votes', { count: formatValue(props.rating.count) }, props.rating.count) }}
        </span>
    </Typography>
</template>
<script lang="ts" setup>
import { Rating } from '@/types'
import { formatValue } from '@/utils/numbers'

import SeoOnly from './SeoOnly.vue'
import Typography from './Typography.vue'

const props = withDefaults(defineProps<{ rating: Rating; showLabel?: boolean }>(), {
    showLabel: true,
})
</script>
<style module>
.rating {
    padding-top: 1px;
    display: inline-flex;
    gap: 4px;
}

.average_rating {
    display: inline-block;
    --percent: calc(var(--rating) / 5 * 100%);
    color: rgba(0, 0, 0, 0.2);
    background: linear-gradient(90deg, #ffc850 var(--percent), var(--carbon-500) var(--percent));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 20px;
    line-height: 18px;
    margin-right: 3px;
    margin-top: -4px;
}

.rating_text {
    font-weight: var(--font-weight-accent);
}

.votes {
    color: var(--white-60);
}
</style>
